<template>
  <div id="principal" class="w-100 p-1" v-html="value" :style="cellStyle">
  </div>
</template>

<script>
export default {
  name: 'FilterCollorCellRenderer',
  data () {
    return {
      value: null,
      cellStyle: {}
    }
  },
  beforeMount () {
    if ((this.params.data && this.params.column ? this.params.data[this.params.column.colId] === undefined : false) && this.params.nref) {
      this.value = '#NREF#'
    } else {
      if (this.params.value) {
        this.cellStyle = this.params.cellStyle(this.params)
        this.value = this.params.value
      } else {
        this.value = this.$lang.AGGrid.blanks
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/FilterCollorCellRenderer.vue